import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.8324",
  buildId: "5.0.8324",
  name: "Patch 8324",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-winter2021-update",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2021/11/PatchNote_Update_1920x1080-1080x608.jpg)
""`,
  date: new Date("2021-11-11T18:40:48Z"),
  sections: [

  ],
};
